import { useCallback, useEffect, useMemo, useState } from 'react';

export const useAntdSelect = (filterOption, onSearch) => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 600);

  useEffect(() => {
    if (!isMobile && openDrawer) {
      setOpenDrawer(false);
    }
  }, [isMobile, openDrawer]);

  useEffect(() => {
    const mobileMediaQuery = window.matchMedia('(max-width: 600px)');
    const eventListener = e => setIsMobile(e.matches);

    mobileMediaQuery.addEventListener('change', eventListener);

    // Cleanup the event listener on component unmount
    return () => {
      mobileMediaQuery.removeEventListener('change', eventListener);
    };
  }, []);

  const defaultFilter = useCallback(
    (input, option) =>
      typeof option?.label == 'string'
        ? (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        : (option?.title ?? '').toLowerCase().includes(input.toLowerCase()),
    [],
  );
  const filter = useMemo(
    () => (onSearch ? false : filterOption ? filterOption : defaultFilter),
    [defaultFilter, filterOption, onSearch],
  );

  return { isMobile, filter, openDrawer, setOpenDrawer };
};
